import _ from 'lodash';
import React, { Fragment } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react';

import LibraryItem from './library-item';
const injectWithStores = inject('artistStore');

export default injectWithStores(({artistStore, member }) => {
	artistStore.fetchIfEmpty();
	if (artistStore.isLoading) {

		return (<h1>Loading...</h1>);
	}

	const activeSubscriptions = member.subscribedTo.filter(s => s.active !== false);

	// BUG FIX: previously this also required that the FIRST subscription's
	// artist be present in artistStore.items. That's a stale guard:
	// (a) it only checks index 0, and (b) artistStore now fetches from the
	// members BFF which filters to status: 'ACTIVE' — so subscriptions to
	// pending/cancelled/inactive artists silently disappeared from My Music.
	// LibraryItem only needs the artistID (to look up songs); the artist doc
	// itself doesn't need to be in the browse store.
	if (_.isEmpty(activeSubscriptions)) {

		return (
			<div className="cell small-12 text-center" style={{marginTop:'20vh'}}>
					<div className="no-result-text dropfade-text">You aren't subscribed to anyone yet.</div>
					<div className="no-result-text dropfade-subtext margin-top-1" style={{fontSize:'1.25em'}}>
						Remember, when you subscribe to an artist, their entire Muzado catalog is available to stream, download and <b>keep</b>!
					</div>
				</div>
		);
	}

	return (
		<Fragment>
			<h4 className="subheader">
				{ member.firstNamePlural } Library
			</h4>

			{
				activeSubscriptions.map(({ artistID }) => (
					<LibraryItem key={ artistID } artistID={ artistID } />
				))
			}
		</Fragment>
	);
});
